import Typography from "../Typography/Typography";
import { useNavigate } from "react-router-dom";
import { useGetMergeList } from "../../hooks/useCrm";
import { AiFillDelete, AiOutlineImport } from "react-icons/ai";
import Button from "../Button/Button";
import { useState } from "react";
import { DeleteMergeItemModal } from "../Dialog/DeleteMergeItemModal";
import UpdateMergeItemModal from "../Dialog/UpdateMergeItemModal";
function MergeList({ id, handleClose }) {
  const [show, setShow] = useState({ delete: false, update: false });
  const [item, setItem] = useState();
  const navigate = useNavigate();
  const { data } = useGetMergeList({ IdSalesOpportunities: id });
  const list = data?.data?.list;

  return (
    <>
      {list?.length ? (
        <Typography className="mt-4 mb-2">زیرمجموعه ها</Typography>
      ) : null}
      {list?.map((item, index) => (
        <div className="col-12 py-2 flex justify-between items-center border-b border-b-slate-100">
          <div className="flex">
            {index + 1}
            {"-"}
            <Typography
              className="text-[14px] cursor-pointer"
              onClick={() => {
                navigate(
                  `/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`,
                  {
                    replace: true,
                  }
                );
                handleClose();
              }}
            >
              {(item.FirstName ? item.FirstName : "") +
                " " +
                (item.LastName ? item.LastName : "")}{" "}
              {item.type === "پرونده اصلی" ? "(پرونده اصلی)" : null}
            </Typography>
          </div>
          <div className="flex gap-x-2">
            <Button
              bgColor="#009EF7"
              className="!m-0"
              onclick={() => {
                setShow({ ...show, update: true });
                setItem(item);
              }}
            >
              <AiOutlineImport color="#fff" />
            </Button>
            <Button
              bgColor="#F1416C"
              className="!m-0"
              onclick={() => {
                setShow({ ...show, delete: true });
                setItem(item);
              }}
            >
              <AiFillDelete color="#fff" />
            </Button>
          </div>
        </div>
      ))}
      <DeleteMergeItemModal
        show={show.delete}
        handleClose={() => setShow({ ...show, delete: false })}
        item={item}
      />
      <UpdateMergeItemModal
        show={show.update}
        handleClose={() => setShow({ ...show, update: false })}
        item={item}
      />
    </>
  );
}

export default MergeList;
